module.exports = __webpack_public_path__ + "static/media/styling-and-furnishing.5ab53458.png";